export default "__VITE_ASSET__4f7bfc6a__"